import React from 'react';
import { NavMenuButton } from '@trussworks/react-uswds';

export function USWDSNavMenuButton(props) {
  return <NavMenuButton {...props} />;
}
